export enum ReelsCascadingStates {
    INIT_STATE = 'init',
    BASIC_STATE = 'basic',
    RELEASE_SYMBOLS_STATE = 'release_symbols',
    FILL_IN_STATE = 'filling_symbols',
    COLLAPSE = 'collapse'
}